import type * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Zastępnik wczytywania.
 *
 * Kształtem odpowiada docelowej treści, żeby układ nie skakał po wczytaniu —
 * kręciołek na środku wymusza przerysowanie całej strony, a to widać.
 */
export function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      // Tło i przebiegające światło rysuje `styles.css` po `data-slot` — jedno
      // światło przez wszystkie szkielety naraz, a nie pulsowanie każdego osobno.
      className={cn("rounded-md", className)}
      {...props}
    />
  );
}

/** Stałe klucze wierszy zastępczych — indeks tablicy nie nadaje się na klucz. */
const ROW_KEYS = ["r1", "r2", "r3", "r4", "r5", "r6"] as const;

/**
 * Wiersze zastępcze dla list w oknach (wersje odcinka, napisy, pliki na dysku):
 * plakietki, opis i przycisk w tych miejscach, w których stanie treść.
 */
export function SkeletonRows({ count = 4 }: { count?: number }) {
  return (
    <ul aria-hidden="true" className="flex flex-col gap-2">
      {ROW_KEYS.slice(0, Math.min(count, ROW_KEYS.length)).map((key) => (
        <li key={key} className="flex items-center gap-2 rounded-lg border border-border p-3">
          <Skeleton className="h-5 w-16" />
          <Skeleton className="h-5 w-14" />
          <Skeleton className="h-4 max-w-[14rem] flex-1" />
          <Skeleton className="ml-auto h-8 w-20" />
        </li>
      ))}
    </ul>
  );
}
